import React, {useEffect, useState} from 'react';
import {Route, Routes, useNavigate} from 'react-router-dom';
import './App.css'
import LivePage from "./pages/LivePage.jsx";
import LiveDetailPage from "./pages/LiveDetailPage.jsx";
import {
    Button,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownTrigger,
    Link,
    Navbar,
    NavbarContent,
    NavbarItem
} from "@heroui/react";


import ListPage from "./pages/ListPage";
import LiverPage from "./pages/LiverPage";
import StatusPage from "./pages/StatusPage";
import RankDialog, {MoneyRankDialog} from "./components/RankDialog";
import UserPage from "./pages/UserPage";
import {AnimatePresence, motion} from "framer-motion";
import NoticeDialog from "./components/NoticeDialog";
import axios from "axios";
import SearchPage from "./pages/SearchPage";
import RawPage from "./pages/RawPage";
import ComparePage from "./pages/ComparePage";
import GeoPage from "./pages/GeoPage";
import ReactionPage from "./pages/ReactionPage";
import SettingDialog from "./components/SettingDialog";
import DemoPage from "./pages/DemoPage";
import BoxPage from "./pages/BoxPage";
import BlackListPage from "./pages/BlackListPage";
import CommentForm from "./components/CommentForm";

const calcHeight = () => {
    const vh = window.innerHeight;
    const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
    const result = vh - 4 * rem;
    return result;
}
const MessageIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 1024 1024"
         style={{ width: '32px', height: '32px' }}>
        <path
            d="M464 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm200 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm661.2-173.6c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z" />
    </svg>
);

function BasicLayout() {


    const menu = [{
        Name: 'Overview',
        Path: '/'
    }, {
        Name: 'List', Path: '/list'
    }, {
        Name: 'Search', Path: '/search'
    }, {
        Name: 'Status', Path: '/stat'
    }, {Name: "Raw", Path: '/raw'}, {Name: 'PK', Path: '/pk'}
    ]

    const [ind, setInd] = React.useState(0);

    const redirect = useNavigate()

    const [showDownload, setShowDownload] = React.useState(false);

    const [showRank, setShowRank] = React.useState(false);

    const [showNotice, setShowNotice] = React.useState(false);

    const [content, setContent] = React.useState("");

    const [showSetting,setShowSettings] = React.useState(false)


    const [showMoneyRank, setShowMoneyRank] = React.useState(false)

    const [opacity,setOpacity] = React.useState(window.getOpacity())

    useEffect(() => {
        axios.get("/about.md").then((response) => {
            setContent(response.data)

            if (navigator.userAgent !== 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/137.0.0.0 Safari/537.36') {
                var last = localStorage.getItem("news")
                if (last === null || last !== response.data) {
                    localStorage.setItem("news",response.data)
                    fetchMoney(true)
                    fetchGuild(true)
                    setShowNotice(true)
                }
            }


        })
    }, [])
    const [commentOpen,setCommentOpen] = useState(false);
    const hide = location.href.includes("hide") || window.parent !== window
    return (

        <div>
            <CommentForm isOpen={commentOpen} onChange={() => setCommentOpen(!commentOpen)} onClose={() => setCommentOpen(false)}/>
            <div className={'fixed right-[3vw] bottom-[3vw] z-40'}>
                <Button
                    isIconOnly
                    startContent={<MessageIcon/>}
                    onClick={() => {
                        setCommentOpen(true)
                    }}
                />
            </div>
            {showNotice && <NoticeDialog onClose={() => {
                setShowNotice(false);
                setCommentOpen(true)
            }} content={content}></NoticeDialog>}
            {showRank && <RankDialog open={showRank} onClose={() => {
                setShowRank(false)
            }}/>}
            {showMoneyRank && <MoneyRankDialog open={showMoneyRank} onClose={() => {
                setShowMoneyRank(false)
            }}/>}
            {showSetting && <SettingDialog onOpacityChange={(e) => {
                setOpacity(e)
            }} onClose={() => {
                setShowSettings(false)
            }}/>}
            {!hide && <Navbar style={{}}>
                <NavbarContent style={{display: "flex", justifyContent: "center", "overflow": "scroll"}}
                               className={'scrollbar-hide'}>
                    {
                        menu.map((item, index) => (
                            <NavbarItem isActive={index === ind} key={index}>
                                <Link color="foreground" onPress={() => {
                                    setInd(index);
                                    redirect(item.Path);

                                }}>
                                    {item.Name}
                                </Link>
                            </NavbarItem>
                        ))

                    }
                    <Dropdown>
                        <DropdownTrigger>
                            <Link>
                                Misc
                            </Link>
                        </DropdownTrigger>
                        <DropdownMenu>
                            <DropdownItem key="view" onClick={() => {
                                setShowDownload(true);
                            }}>Bili Downloader</DropdownItem>
                            <DropdownItem key="rank" onClick={() => {
                                setShowRank(true);
                            }}>Level Rank</DropdownItem>
                            <DropdownItem key="money-rank" onClick={() => {
                                setShowMoneyRank(true);
                            }}>Money Rank</DropdownItem>
                            <DropdownItem key="notice" onClick={() => {
                                setShowNotice(true);
                            }}>Notice & Changelog</DropdownItem>
                            <DropdownItem key="setting" onClick={() => {
                                setShowSettings(true);
                            }}>Setting</DropdownItem>
                            <DropdownItem key="reaction" onClick={() => {
                                redirect("/reactions")
                            }}>Reaction</DropdownItem>
                            <DropdownItem key="geo" onClick={() => {
                                redirect("/geo")
                            }}>Geo</DropdownItem>
                            <DropdownItem key="blacklist" onClick={() => {
                                redirect("/relation")
                            }}>Relation</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </NavbarContent>
            </Navbar>}
            <div className={`site-layout-background`} style={{padding: 24, width: '100%', height: `${calcHeight()}px`,opacity:parseInt(opacity)/100}}>
                <AnimatePresence mode="wait">
                    <Routes location={location} key={location.pathname} >
                        <Route path="/" element={<PageWrapper><LivePage/></PageWrapper>}/>
                        <Route path="/lives" element={<PageWrapper><LivePage/></PageWrapper>}/>
                        <Route path="/search" element={<PageWrapper><SearchPage/></PageWrapper>}/>
                        <Route path="/lives/:id" element={<PageWrapper><LiveDetailPage/></PageWrapper>}/>
                        {/*<Route path="/chat" element={<PageWrapper><ChatPage/></PageWrapper>}/>*/}
                        <Route path="/list" element={<PageWrapper><ListPage/></PageWrapper>}/>
                        <Route path="/stat" element={<PageWrapper><StatusPage/></PageWrapper>}/>
                        <Route path="/liver/:id" element={<PageWrapper><LiverPage/></PageWrapper>}/>
                        <Route path="/user/:id" element={<PageWrapper><UserPage/></PageWrapper>}/>
                        <Route path="/raw" element={<PageWrapper><RawPage/></PageWrapper>}/>
                        <Route path="/pk" element={<PageWrapper><ComparePage/></PageWrapper>}/>
                        <Route path="/geo" element={<PageWrapper><GeoPage/></PageWrapper>}/>
                        <Route path="/reactions" element={<PageWrapper><ReactionPage/></PageWrapper>}/>
                        <Route path="/demo" element={<PageWrapper><DemoPage/></PageWrapper>}/>
                        <Route path="/box" element={<PageWrapper><BoxPage/></PageWrapper>}/>
                        <Route path="/relation" element={<PageWrapper><BlackListPage/></PageWrapper>}/>
                    </Routes>
                </AnimatePresence>

            </div>
        </div>
    )

}

function PageWrapper({children}) {
    return (
        <motion.div
            initial={{opacity: 0, x: 20}}
            animate={{opacity: 1, x: 0}}
            exit={{opacity: 0, x: -20}}
            transition={{duration: 0.3}}
            className="h-full"
        >
            {children}
        </motion.div>
    );
}

export default BasicLayout;